import Group from 'components/utils/Group'
import React, { useEffect, useRef } from 'react'
import BodyText from 'LuxKit/Typography/BodyText'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import BusinessTravellerStepCircle from './BusinessTravellerStepCircle'
import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import { centreElementInView } from 'lib/window/scrollUtils'
import { objectEntries } from 'lib/object/objectUtils'

interface Props {
  steps: App.BusinessTraveller.BusinessSignupSteps;
  stepStatuses: App.BusinessTraveller.BusinessSignupStepKeyStatuses
}

function BusinessTravellerStepGroup(props: Props) {
  const { steps, stepStatuses } = props
  const stepsRef = useRef<Record<App.BusinessTraveller.BusinessSignupStepKey, HTMLDivElement | null>>({
    validate_email: null,
    account_details: null,
    create_password: null,
  })

  useEffect(() => {
    const activeStepEntry = objectEntries(stepStatuses).find(([, status]) => status === 'active')
    if (activeStepEntry) {
      const [activeStep] = activeStepEntry
      const activeElement = stepsRef.current[activeStep]
      if (activeElement) {
        centreElementInView(activeElement)
      }
    }
  }, [stepStatuses])

  return (
    <HorizontalContainerWithFadedOverflow gap={8}>
      {steps.map((step, index) =>
        <Group
          direction="horizontal"
          verticalAlign="center"
          key={step.stepKey}
          gap={8}
          ref={(node) => {
            stepsRef.current[step.stepKey] = node
          }}
        >
          <BusinessTravellerStepCircle status={stepStatuses[step.stepKey]} text={String(index + 1)} />
          <BodyText
            variant="medium"
            wrap="no-wrap"
            colour={stepStatuses[step.stepKey] === 'pending' ? 'neutral-four' : undefined}
          >
            {step.label}
          </BodyText>
          {(index !== steps.length - 1) && <LineAngleRightIcon colour="neutral-five" />}
        </Group>,
      )}
    </HorizontalContainerWithFadedOverflow>
  )
}

export default BusinessTravellerStepGroup
